<template>
  <Pane v-model="documentsPane.isOpen"
        :value="documentsPane.isOpen"
        :current-tab="documentsPane.tab"
        eager
        :tabs="tabs"
        temporary
        data-locator="documents-share-by-mail-pane"
  >
    <template v-if="documentsPane.isOpen" #content-share-email>
      <DocumentsShareByEmailPane />
    </template>
  </Pane>
</template>

<script>
import { mapState } from 'vuex'

import Pane from '@/common/Pane.vue'

import DocumentsShareByEmailPane from './DocumentsShareByEmailPane.vue'

export default {
  name: 'DocumentsPane',
  components: { DocumentsShareByEmailPane, Pane },
  data () {
    return {
      tabs: [
        {
          title: this.$t('project.documents.pane.DocumentsPane.shareByEmail'),
          id: 'share-email',
        },
      ],
    }
  },
  computed: {
    ...mapState('documents', ['documentsPane']),
  },
}
</script>
